import { CapoPlugin } from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];